import React from "react";
import { Check } from "lucide-react";

export default function StepIndicator({ steps, current }) {
    return (
        <div className="flex items-center justify-between gap-2 max-w-3xl mx-auto" data-testid="step-indicator">
            {steps.map((s, i) => {
                const done = i < current;
                const active = i === current;
                return (
                    <React.Fragment key={i}>
                        <div className="flex flex-col items-center text-center min-w-0 flex-1">
                            <span
                                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-data font-semibold transition-all ${
                                    done
                                        ? "bg-teal text-white"
                                        : active
                                        ? "bg-dark-navy text-white ring-4 ring-teal/20"
                                        : "bg-slate-200 text-slate-500"
                                }`}
                            >
                                {done ? <Check className="w-4 h-4" /> : i + 1}
                            </span>
                            <span
                                className={`mt-2 text-[11px] uppercase tracking-wider font-semibold truncate max-w-full ${
                                    active ? "text-dark-navy" : "text-slate-500"
                                }`}
                            >
                                {s}
                            </span>
                        </div>
                        {i < steps.length - 1 && (
                            <div className={`flex-1 h-0.5 mb-6 ${i < current ? "bg-teal" : "bg-slate-200"}`} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
